<template>
  <div class="c-sitter__feedback">
    <fieldset id="bad_public_feedback" class="c-feedback__form" name="bad_public_feedback">
      <legend class="h3 c-rating__question">We’re sorry to hear you had an unsatisfactory experience.</legend>
      <span class="c-optional__label">Optional</span>
      <p class="c-feedback__title">Leave a public review of {{ sitterFirstName }}.</p>
      <PoppinsTextArea
        id="update_review_text"
        v-model="publicFeedback"
        class="mb-32 review-feedback-box"
        labelName="Your review..."
        :rows="6"
        @keyup-once="ratingSegmentEvent('Review Started')"
        @update:model-value="onInput"
      />
      <PoppinsButton
        id="updateReview"
        type="submit"
        size="medium"
        class="mr-8 w-full sm:!w-auto"
        value="Post review"
        @click.prevent="updateReview"
      />
      <PoppinsButton value="Skip" :href="skipHref" variant="text" class="w-full sm:!w-auto mt-16 sm:!mt-0" @click="handleSkip" />
    </fieldset>
  </div>
</template>

<script lang="ts">
import TextArea from '@/components/textarea/TextArea.vue';
import Button from '@/components/button/Button.vue';

export default {
  name: 'UpdateFeedback',
  components: {
    PoppinsTextArea: TextArea,
    PoppinsButton: Button,
  },
  props: {
    returnPath: {
      type: String,
      required: true,
    },
    updateReview: {
      type: Function,
      required: true,
    },
    sitterFirstName: {
      type: String,
      required: true,
    },
    ratingSegmentEvent: {
      type: Function,
      required: false,
      default: () => {},
    },
    onSkip: {
      type: Function,
      required: false,
      default: null,
    },
  },
  data(): any {
    return {
      publicFeedback: '',
    };
  },
  computed: {
    skipHref(): string {
      if (this.onSkip) {
        return '';
      }
      return this.returnPath;
    },
  },
  methods: {
    onInput() {
      this.$emit('update:modelValue', this.publicFeedback);
    },
    handleSkip(event) {
      this.ratingSegmentEvent('Review Skipped');
      if (this.onSkip) {
        event.preventDefault();
        this.onSkip();
      }
    },
  },
};
</script>
